(() => {
  if (customElements.get('cbj-card-gallery')) return;
  const pending = new Set();
  let frame = 0;
  const drain = () => {
    frame = 0;
    const gallery = pending.values().next().value;
    if (!gallery) return;
    pending.delete(gallery);
    if (gallery.isConnected) gallery.initialise();
    if (pending.size) frame = requestAnimationFrame(drain);
  };
  const enqueue = (gallery) => {
    pending.add(gallery);
    if (!frame) frame = requestAnimationFrame(drain);
  };
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (!isIntersecting) return;
          observer.unobserve(target);
          enqueue(target);
        });
      }, { rootMargin: '200px 0px' })
    : null;
  customElements.define('cbj-card-gallery', class extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('.swiper');
      if (!this.slider || this.slider.querySelectorAll('.swiper-slide').length < 2) return;
      if (observer) observer.observe(this);
      else enqueue(this);
    }
    initialise() {
      if (this.slider.swiper || typeof window.Swiper !== 'function') return;
      this.instance = new window.Swiper(this.slider, {
        nested: true,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 800,
        pagination: {
          el: this.slider.querySelector('.pd-pagination'),
          clickable: true
        }
      });
    }
    disconnectedCallback() {
      observer?.unobserve(this);
      pending.delete(this);
      this.instance?.destroy(true, true);
      this.instance = null;
    }
  });
})();


